import {Line} from 'react-chartjs-2';
import React from 'react';
import { LineComponentProps } from '../types';

export const LineComponent: React.FC<Omit<LineComponentProps , 'type'>> = (props) => {
    const {
        data,
        chartProps
    } = props;
    return (
        <Line
            {...(chartProps || {} )}
            data={data}
        />
    );
};